// AdminPresetsPage.tsx — the legacy pipeline's channel presets, READ-ONLY (session 7, 7c). The table is generated from the
// video-type catalogue at the backend's boot and dropped once the last tenant leaves the legacy pipeline; a change is a
// catalogue change (vms-contracts VIDEO_TYPES), seen on the Video types page.
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/Card.tsx";
import { Badge } from "@/components/ui/Badge.tsx";
import { Spinner } from "@/components/ui/Spinner.tsx";
import { adminApi } from "@/api/admin.ts";

export function AdminPresetsPage() {
  const { data, isLoading } = useQuery({ queryKey: ["admin", "presets"], queryFn: () => adminApi.listPresets() });
  if (isLoading) return <div className="flex justify-center py-12"><Spinner /></div>;
  const presets = data?.presets ?? [];
  return (
    <div className="mx-auto max-w-4xl p-8">
      <h1 className="text-xl font-semibold text-surface-900 mb-2">Channel Presets</h1>
      <p className="text-sm text-surface-500 mb-6">
        Generated from the video-type catalogue — read-only. To change a type, change its catalogue entry
        (see <Link to="/admin/video-types" className="underline">Video types</Link>).
      </p>
      <div className="space-y-3">
        {presets.length === 0 && (
          <Card><CardContent className="py-8 text-center text-surface-400 text-sm">No presets.</CardContent></Card>
        )}
        {presets.map((p) => (
          <Card key={p.id}>
            <CardContent className="py-4">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-medium text-sm text-surface-900">{p.displayName}</span>
                <Badge variant={p.isActive ? "success" : "muted"}>{p.isActive ? "Active" : "Inactive"}</Badge>
                <span className="text-xs text-surface-400 font-mono">{p.id}</span>
              </div>
              <p className="text-xs text-surface-500 truncate">{p.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
